import { apiClient, getLoggedinUser } from "helpers/api_helper";
import { SaleseEntryCounts } from "modules/dashboard/model";

export const getAllDashboardCounts = async () => {
    try {
        const user = getLoggedinUser();
        if (!user) {
            return null;
        }
        const response = await apiClient.get(`/api/v1/Dashboard/GetDashboardCountDetails`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getDashboardFilterData = async (model: SaleseEntryCounts) => {
    try {
        const response = await apiClient.post('/api/v1/Dashboard/GetDaboardFiltterData', model);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
